import { IPost, UserProfile } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { ErrorBoundary } from '../../ui';
import { BlogPostSlider } from './BlogPostSlider';

interface IProps {
  posts: IPost[];
  allLoading: boolean;
  moreLoading: boolean;
  showSeeMoreButton: boolean;
  failedToLoadHelpBlogs: boolean;
  seeMorePressed: () => void;
  userProfile: UserProfile;
  t: (key: string) => string;
}

class HelpBlogPosts extends PureComponent<IProps> {

  public render() {
    const {
      t,
      allLoading,
      moreLoading,
      posts,
      failedToLoadHelpBlogs,
    } = this.props;

    if (failedToLoadHelpBlogs) {
      return <></>;
    }

    return (
      <ErrorBoundary childTreeName={'Help Blog Posts'}>
        <BlogPostSlider heading={t('dashboard:howFitillionWorks')}
                        posts={posts}
                        loading={allLoading}
                        seeMoreCardText={t('dashboard:seeAllHelpPosts')}
                        showSeeMoreButton={false}
        />
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state) => ({
  posts: state.summaryDashboard.data.helpBlogs,
  allLoading: state.summaryDashboard.view.seeAllHelpPostsRequestInProgress,
  failedToLoadHelpBlogs: state.summaryDashboard.view.helpBlogPostsFailure,
});


export default connect(mapStateToProps)(HelpBlogPosts);
